
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';



// All the sliders on the site

jQuery(function($){
  let windowWidth = jQuery(window).width();


  $('.gallery-slider').each(function(index, element) {
    const gallery = new Swiper($(element).find('.swiper-container')[0], {
        loop: true, 
        spaceBetween: 10,
        slidesPerView: 1,
        lazy: true, 
        speed: 200, 
        navigation: {
            nextEl: $(element).find('.gallery__next')[0],
            prevEl: $(element).find('.gallery__prev')[0],
        },
        on: {
            slideChange: function () {
                // Update slide counter
                var currentSlide = this.realIndex + 1;
                var totalSlides = this.slides.length;
                $(element).find('.gallery__pagination .count').text(currentSlide + ' van ' + totalSlides);
            },
        },
    });
  });

  $('.slider').each(function(index, element) {
    let slidesPerView = $(element).find('.swiper-container').data('slides');
    let autoPlay = $(element).data('autoplay');

    if (autoPlay) {
        autoPlay = {
            delay: 3000, // Customize as needed
            disableOnInteraction: false
        };
    } else {
        autoPlay = false;
    }

    let noExtra = $(element).data('no-extra');


    if ($(element).find('.swiper-container').length === 0) {
        return;
    }

    // Initialize Swiper
    const slider = new Swiper($(element).find('.swiper-container')[0], {
        spaceBetween: 20,
        slidesPerGroup: 1,
        autoplay: autoPlay,
        lazy: true, 
        speed: 200, 
        navigation: {
          nextEl: $(element).find('.slider__next').toArray(), // Select all 'next' buttons
          prevEl: $(element).find('.slider__prev').toArray(), // Select all 'prev' buttons
        },
        breakpoints: {
          // When the viewport is >= 768px
            768: {
                slidesPerView: slidesPerView || 1, 
            },
            // When the viewport is <= 767px (mobile)
            767: {
                slidesPerView: 1, 
            }
        },
        on: {
            init: function () {
              if ($(window).width() > 767 && !noExtra){
                addExtraSlide(this);
              }
                
                updateNavigationState(this, element);
            },
            slideChange: function () {
                updateNavigationState(this, element);
            },
            reachBeginning: function () {
                updateNavigationState(this, element);
            },
            reachEnd: function () {
                updateNavigationState(this, element);
            }
        }
    });

    function addExtraSlide(swiperInstance) {
      const $wrapper = $(swiperInstance.wrapperEl);
      const $extraSlide = $('<div class="swiper-slide"></div>');
      $wrapper.append($extraSlide);
      swiperInstance.update(); 
  }

    function updateNavigationState(sliderInstance, element) {
        const $prevButton = $(element).find('.slider__prev');
        const $nextButton = $(element).find('.slider__next');

        // Disable/Enable the previous button
        if (sliderInstance.isBeginning) {
            $prevButton.addClass('disabled');
        } else {
            $prevButton.removeClass('disabled');
        }

        // Disable/Enable the next button
        if (sliderInstance.isEnd) {
            $nextButton.addClass('disabled');
        } else {
            $nextButton.removeClass('disabled');
        }
      }
  });

});


const productGalleryPopupThumbnails = new Swiper('.product-gallery__thumbnails.popup-slider', {
    loop: false,
    lazy: true, 
    slidesPerView: 10, // Default for desktop
    spaceBetween: 5,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    freeMode: true,  
    navigation: {
        nextEl: '.product-gallery__next',
        prevEl: '.product-gallery__prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 8,
        },
        1024: {
            slidesPerView: 10,
        }
    }
});
    

export const productGalleryPopup = new Swiper('.product-gallery__slider.popup-slider', {
    loop: true,
    lazy: true, 
    slidesPerView: 1,
    navigation: {
        nextEl: '.product-gallery__next',
        prevEl: '.product-gallery__prev',
    },
    thumbs: {
        swiper: productGalleryPopupThumbnails,
    }   
});
